import React from 'react'
import Multiselect from '@cloudscape-design/components-themed/multiselect'

// https://cloudscape.design/components/multiselect
export function RadMultiselect ({ ...rest }) {
  return (
    <Multiselect {...rest} />
  )
}
